import React from 'react';
import PropTypes from 'prop-types';
import Button from "../../../components/Button";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import TableColumns from "./TableSettings/TableColumns";
import {useTranslation} from "react-i18next";

export const getLocalStorageColumnsKey = (tableKeyName) => {
  return `t${tableKeyName}-cs`;
}

const getColumnsInitial = (tableKeyName, columns) => {
  let _columns = localStorage.getItem(getLocalStorageColumnsKey(tableKeyName))

  if(_columns && JSON.parse(_columns)){
    _columns = JSON.parse(_columns);
    const _columnsOrder = _columns.map(c => c.id)

    _columns = columns
      .filter(column => column.disabled !== true)
      .filter(column => !column.smallViewColumn)
      .map(column => {
        const col = _columns.find(_c => _c.id === column.dataField)

        return {
          id: column.dataField,
          isActive: col ? col.isActive : column.defaultDisplayable,
          width: col ? col.width : (column?.headerStyle?.widthDefault ?? column?.headerStyle?.width),
        }
      })
      .sort((a,b) => _columnsOrder.indexOf(a.id) > _columnsOrder.indexOf(b.id) ? 1 : -1)

  }else{
    _columns = columns
      .filter(column => column.disabled !== true)
      .filter(column => !column.smallViewColumn)
      .map(column => ({
        id: column.dataField,
        isActive: column.defaultDisplayable,
        width: column?.headerStyle?.widthDefault ?? column?.headerStyle?.width,
      }))
  }

  return _columns
    .filter(column => !!columns.find(c => c.dataField === column.id))
    .map(column => ({
      ...column,
      name: columns.find(c => c.dataField === column.id).text,
    }))
}

const TableSettings = (props) => {
  const { t } = useTranslation('app_table')
  const [columns, setColumns] = React.useState(getColumnsInitial(props.tableKeyName, props.columns));
  const [modalOpen, setModalOpen] = React.useState(false);
  const toggleModalOpen = () => setModalOpen(!modalOpen);

  const save = () => {
    localStorage.setItem(getLocalStorageColumnsKey(props.tableKeyName), JSON.stringify(columns))
    setModalOpen(false)
    props.onChanged()
  }

  const unset = () => {
    localStorage.removeItem(getLocalStorageColumnsKey(props.tableKeyName))
    setModalOpen(false)
    props.onChanged()
  }

  return (
    <div className="d-inline-block">
      <Button tooltip={t('table_settings.btn.open')} className="ml-2" color="light" onClick={toggleModalOpen}><i className="fas fa-cogs" /></Button>
      {modalOpen && <Modal isOpen size={'xl'}>
        <ModalHeader>{t('table_settings.modal_title')}</ModalHeader>
        <hr className="my-0"/>
        <ModalBody>
          <TableColumns
            columns={columns}
            onColumnsUpdate={setColumns}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="light" size={'sm'} className="mb-0 mr-auto" onClick={unset}>{t('table_settings.btn.unset')}</Button>
          <Button color="secondary" className="mb-0" onClick={toggleModalOpen}>{t('common:btn.cancel')}</Button>
          <Button
            color="primary"
            onClick={save}
          >{t('common:btn.save')}</Button>
        </ModalFooter>
      </Modal>}
    </div>
  );
};

TableSettings.propTypes = {
  tableKeyName: PropTypes.string.isRequired,
  onChanged: PropTypes.func.isRequired,
};

export default TableSettings;
